// "inline scale"
const x = {
  xs: '0.25rem',
  s: '0.5rem',
  m: '1rem',
  l: '1.5rem',
  xl: '2rem',
} as const;

export const space = {
  component: {
    x,
    // "spacing scale"
    y: {
      xs: '0.25rem',
      s: '0.5rem',
      m: '1rem',
      l: '1.5rem',
      xl: '2rem',
      xxl: '2.5rem',
      xxxl: '3rem',
    },
  },
  layout: {
    x,
    // "layout scale"
    y: {
      xs: '1rem',
      s: '1.5rem',
      m: '2rem',
      l: '3rem',
      xl: '4rem',
      xxl: '6rem',
      xxxl: '10rem',
    },
  },
} as const;

export type Spaces = typeof space;

export const px = (pxStr: string): number => parseFloat(pxStr);
